<div class="mx-auto px-4 py-8 sm:px-6 lg:px-8">
  <form [formGroup]="form" (ngSubmit)="onSubmit()"
    class="bg-white rounded-xl shadow-sm border border-gray-200 p-6 sm:p-10 space-y-8">
    <div class="flex items-center justify-between gap-4 pb-4">
      <img src="assets/img/logo_unchk.png" alt="Université numérique Cheikh Hamidou KANE"
        class="h-12 sm:h-16 w-auto object-contain" />
      <img src="assets/img/logo_master_card.png" alt="Mastercard Foundation"
        class="h-12 sm:h-16 w-auto object-contain" />
    </div>
    <header class="space-y-4 border-b border-gray-100 pb-6">
      <h1 class="text-xl sm:text-2xl font-bold text-gray-900">
        Formulaire de consentement des participants au programme Force N
      </h1>
      <p class="text-sm text-gray-600 leading-relaxed">
        L'université numérique Cheikh Hamidou KANE s'engage à améliorer ses programmes et à veiller
        à ce qu'ils aient un impact positif sur les participants. Pour ce faire, nous recueillons et
        analysons des données sur les participants aux programmes. Nous accordons une grande importance
        à votre vie privée et nous nous engageons à protéger vos données personnelles. Ce formulaire de
        consentement explique comment nous collectons, utilisons et partageons vos informations
        personnelles dans le cadre du Programme Force N. Veuillez lire attentivement ce formulaire et
        le signer pour indiquer votre consentement.
      </p>
      <p class="text-sm font-semibold text-gray-800">
        Veuillez lire attentivement ce formulaire avant de prendre votre décision.
      </p>

      <dl class="grid grid-cols-1 sm:grid-cols-2 gap-3 text-sm bg-gray-50 rounded-lg p-4 mt-2">
        <div>
          <dt class="font-semibold text-gray-700">Nom du programme</dt>
          <dd class="text-gray-600">Force N</dd>
        </div>
        <div>
          <dt class="font-semibold text-gray-700">Collecteur de données</dt>
          <dd class="text-gray-600">Université numérique Cheikh Hamidou KANE</dd>
        </div>
      </dl>
      <div class="flex items-center gap-2 pt-2">
        <span class="h-2 flex-1 rounded-full" [ngClass]="currentPage === 1 ? 'bg-blue-600' : 'bg-blue-200'"></span>
        <span class="h-2 flex-1 rounded-full" [ngClass]="currentPage === 2 ? 'bg-blue-600' : 'bg-blue-200'"></span>
      </div>
      <p class="text-xs text-gray-400">Étape {{ currentPage }} sur 2</p>
    </header>

    <ng-container *ngIf="currentPage === 1">
      <section class="space-y-3">
        <h2 class="text-base font-semibold text-gray-900">1. Objectif de la collecte et de l'utilisation des données
        </h2>
        <p class="text-sm text-gray-600 leading-relaxed">
          Nous collectons vos données personnelles afin d'analyser les progrès du programme et de
          l'améliorer, et de tirer des enseignements des données collectées, notamment pour contrôler
          et évaluer l'efficacité du programme Force N et apprendre comment l'améliorer pour les
          futurs participants.
        </p>
      </section>

      <section class="space-y-3">
        <h2 class="text-base font-semibold text-gray-900">2. Quelles sont les données collectées ?</h2>
        <p class="text-sm text-gray-600">Nous pouvons recueillir tout ou partie des informations suivantes vous
          concernant :</p>
        <ul class="text-sm text-gray-600 space-y-1 pl-5" style="list-style-type: disc;">
          <li *ngFor="let item of donneesCollectees" style="display: list-item;">{{ item }}</li>
        </ul>
      </section>

      <section class="space-y-3">
        <h2 class="text-base font-semibold text-gray-900">3. Avec qui vos données seront-elles partagées ?</h2>
        <p class="text-sm text-gray-600">Nous pouvons partager vos données avec les parties suivantes :</p>
        <ul class="text-sm text-gray-600 space-y-1 pl-5" style="list-style-type: disc;">
          <li style="display: list-item;">Mastercard Foundation et d'autres partenaires de mise en œuvre</li>
          <li style="display: list-item;">Entités tierces, mandatée par la Fondation Mastercard pour aider au suivi et à
            l'évaluation (par exemple, organisations de stockage et d'analyse de données).</li>
        </ul>
        <p class="text-sm text-gray-600">
          Pour plus d'informations sur la manière dont nous traitons les données personnelles, veuillez contacter :
          <a class="text-blue-600 hover:underline" href="mailto:khoudia.gueye@unchk.edu.sn">Khoudia Gueye</a>.
        </p>
        <p class="text-sm text-gray-600">
          Veuillez consulter
          <a class="text-blue-600 hover:underline" href="https://force-n.sn" target="_blank"
            rel="noopener">https://force-n.sn</a>
          pour accéder à une copie de notre politique en matière de protection de la vie privée.
          La politique de confidentialité de la Fondation est accessible à l'adresse suivante :
          <a class="text-blue-600 hover:underline" href="https://mastercardfdn.org/privacy/" target="_blank"
            rel="noopener">mastercardfdn.org/privacy</a>.
        </p>
      </section>
      <div class="flex justify-end pt-2">
        <button type="button" (click)="goToPage(2)"
          class="px-5 py-2.5 text-sm font-medium rounded-lg bg-blue-600 text-white hover:bg-blue-700 transition">
          Suivant
        </button>
      </div>
    </ng-container>
    <ng-container *ngIf="currentPage === 2">
      <section class="space-y-3">
        <h2 class="text-base font-semibold text-gray-900">4. Vos droits</h2>
        <p class="text-sm text-gray-600 leading-relaxed">
          Vous n'êtes pas obligé de donner votre consentement. Vous pouvez participer à tous les aspects
          du programme, quelle que soit votre décision de partager vos données. Le consentement au
          partage des données est totalement indépendant de la participation au programme. Vous disposez
          des droits suivants concernant vos données personnelles :
        </p>
        <ul class="text-sm text-gray-600 space-y-2 pl-5" style="list-style-type: disc;">
          <li *ngFor="let droit of vosDroits" style="display: list-item;">
            <span class="font-semibold text-gray-800">{{ droit.titre }}</span> {{ droit.description }}
          </li>
        </ul>
      </section>

      <section class="space-y-3">
        <h2 class="text-base font-semibold text-gray-900">5. Retirer son consentement</h2>
        <p class="text-sm text-gray-600 leading-relaxed">
          Vous pouvez à tout moment retirer votre consentement au partage de vos données. Cela n'affectera
          pas votre capacité à participer au programme. Pour retirer votre consentement, veuillez contacter
          Khoudia Gueye par email au
          <a class="text-blue-600 hover:underline"
            href="mailto:khoudia.gueye@unchk.edu.sn">khoudia.gueye@unchk.edu.sn</a>.
        </p>
      </section>

      <section class="space-y-3">
        <h2 class="text-base font-semibold text-gray-900">6. Comprendre vos choix</h2>
        <p class="text-sm text-gray-600 leading-relaxed">
          En acceptant de partager vos données, vous contribuez à la réussite du programme Force N pour
          vous et les futurs participants.
        </p>
      </section>
      <section class="bg-blue-50 border border-blue-100 rounded-lg p-5 space-y-4">
        <label class="flex items-start gap-3 cursor-pointer">
          <input type="checkbox" formControlName="accepte"
            class="mt-1 h-4  rounded border-gray-300 text-blue-600 focus:ring-blue-500" />
          <span class="text-sm font-medium text-gray-800">
            J'accepte que mes données soient communiquées à l'université numérique Cheikh Hamidou KANE,
            à travers Force N, et à la Mastercard Foundation, ainsi qu'à tout tiers chargé du traitement
            des données qu'ils pourraient utiliser aux fins décrites ci-dessus.
          </span>
        </label>
        <p *ngIf="form.get('accepte')?.invalid && form.get('accepte')?.touched" class="text-xs text-red-600">
          Veuillez cocher la case pour continuer.
        </p>

        <p class="text-xs text-gray-500 italic">
          Vous pouvez télécharger une copie de ce consentement après soumission depuis la rubrique
          consentement dans votre espace FODE.
        </p>
      </section>

      <div class="flex justify-between pt-2">
        <button type="button" (click)="goToPage(1)"
          class="px-5 py-2.5 text-sm font-medium rounded-lg border border-gray-300 text-gray-700 hover:bg-gray-50 transition">
          Retour
        </button>
        <button type="submit" [disabled]="submitting"
          class="px-5 py-2.5 text-sm font-medium rounded-lg bg-blue-600 text-white hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed transition">
          {{ submitting ? 'Envoi en cours...' : 'Soumettre mon consentement' }}
        </button>
      </div>
    </ng-container>
  </form>
</div>